var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "page-dialog center-dialog",
      attrs: {
        title: _vm.dialogTitle,
        visible: _vm.visible,
        width: "80%",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": (val) => _vm.emitUpdateVisible(val),
        closed: _vm.handleClosed,
      },
    },
    [
      _c("div", { staticClass: "dialog-content" }, [
        _c(
          "div",
          {
            staticClass: "page-content page-search",
            staticStyle: { padding: "0 20px" },
          },
          [
            _c(
              "el-form",
              {
                staticClass: "search-form-flex",
                attrs: {
                  size: "mini",
                  model: _vm.searchForm,
                  "label-position": "right",
                },
                nativeOn: {
                  submit: function ($event) {
                    $event.preventDefault()
                  },
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 16 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "游戏名称" } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入游戏名称",
                                clearable: "",
                              },
                              model: {
                                value: _vm.searchForm.game_name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "game_name", $$v)
                                },
                                expression: "searchForm.game_name",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "游戏厂商" } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入游戏厂商",
                                clearable: "",
                              },
                              model: {
                                value: _vm.searchForm.game_provider,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "game_provider", $$v)
                                },
                                expression: "searchForm.game_provider",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      {
                        staticStyle: { "text-align": "right" },
                        attrs: { span: 8 },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              loading: _vm.loading,
                            },
                            on: { click: _vm.handleSearch },
                          },
                          [_vm._v("筛选")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", disabled: _vm.loading },
                            on: { click: _vm.handleReset },
                          },
                          [_vm._v("重置")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "page-content" }, [
          _c("div", { staticClass: "transfer-toolbar" }, [
            _c("div", { staticClass: "toolbar-left" }, [
              _c("span", { staticClass: "tip" }, [
                _vm._v("已选择 " + _vm._s(_vm.selectedKeys.length) + " 个游戏"),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "toolbar-right" },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "text",
                      size: "mini",
                      disabled: _vm.selectedKeys.length === 0,
                    },
                    on: { click: _vm.clearSelected },
                  },
                  [_vm._v("清空已选")]
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "table-transfer" }, [
            _c(
              "div",
              { staticClass: "panel" },
              [
                _c("div", { staticClass: "panel-title" }, [_vm._v("全部游戏")]),
                _c(
                  "el-table",
                  {
                    ref: "leftTableRef",
                    attrs: {
                      size: "mini",
                      data: _vm.availableRows,
                      border: "",
                      stripe: "",
                      fit: "",
                      height: "420",
                    },
                    on: { "selection-change": _vm.handleLeftSelectionChange },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        type: "selection",
                        width: "40",
                        align: "center",
                        selectable: _vm.isSelectableLeftRow,
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "game_name",
                        label: "游戏名称",
                        "min-width": "180",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "game-name-cell" },
                                [
                                  _vm.isRelatedRow(scope.row)
                                    ? _c(
                                        "el-tag",
                                        {
                                          staticClass: "related-inline-mark",
                                          attrs: { type: "info", size: "mini" },
                                        },
                                        [_vm._v("已关联")]
                                      )
                                    : _vm._e(),
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.game_name || "-")),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "game_provider",
                        label: "游戏厂商",
                        "min-width": "110",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "game_type",
                        label: "游戏类型",
                        width: "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "tags",
                        label: "游戏标签",
                        "min-width": "100",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formatTagsDisplay(scope.row.tags)
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "status",
                        label: "状态",
                        width: "90",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type:
                                      scope.row.status === 1
                                        ? "success"
                                        : "danger",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.formatStatus(scope.row.status))
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "pagination-container" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.pagination.currentPage,
                        "page-size": _vm.pagination.pageSize,
                        "page-sizes": [10, 20, 50, 100],
                        layout: "total, sizes, prev, pager, next, jumper",
                        total: _vm.pagination.total,
                      },
                      on: {
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.handleCurrentChange,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "actions" },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      size: "mini",
                      disabled: _vm.leftSelectedKeys.length === 0,
                    },
                    on: { click: _vm.addSelected },
                  },
                  [_vm._v(" 选择 ")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      size: "mini",
                      disabled: _vm.rightSelectedKeys.length === 0,
                    },
                    on: { click: _vm.removeSelected },
                  },
                  [_vm._v(" 移除 ")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "panel" },
              [
                _c("div", { staticClass: "panel-title" }, [_vm._v("本次新增")]),
                _c(
                  "el-table",
                  {
                    ref: "rightTableRef",
                    attrs: {
                      size: "mini",
                      data: _vm.selectedRows,
                      border: "",
                      stripe: "",
                      fit: "",
                      height: "420",
                    },
                    on: { "selection-change": _vm.handleRightSelectionChange },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        type: "selection",
                        width: "40",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "game_name",
                        label: "游戏名称",
                        "min-width": "160",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "game_provider",
                        label: "游戏厂商",
                        "min-width": "110",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "game_type",
                        label: "游戏类型",
                        width: "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "tags",
                        label: "游戏标签",
                        "min-width": "100",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formatTagsDisplay(scope.row.tags)
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "status",
                        label: "状态",
                        width: "90",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type:
                                      scope.row.status === 1
                                        ? "success"
                                        : "danger",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.formatStatus(scope.row.status))
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _vm.relatedLoading
                  ? _c("div", { staticClass: "right-loading-tip" }, [
                      _vm._v("正在加载已关联游戏..."),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c(
        "template",
        { slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  return _vm.emitUpdateVisible(false)
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                size: "small",
                loading: _vm.submitLoading,
              },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }